export default "__VITE_ASSET__BJtd6OgV__"